import {baseRequestService} from "../base.ts";

export const eventsEventIdUnreturnPost = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/unreturn`,
    method: 'POST'
})